import { Phone, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';

// Imágenes del cliente
const PRODUCT_ISOVER = "https://customer-assets.emergentagent.com/job_661024ed-50d4-4d78-a636-dd6004c5bf2a/artifacts/qvk1cqi6_IMG_4268.jpeg";
const PRODUCT_PLACO = "https://customer-assets.emergentagent.com/job_661024ed-50d4-4d78-a636-dd6004c5bf2a/artifacts/9i1zzzg2_IMG_4270.jpeg";
// Nuevas imágenes del cliente
const PERFILERIA_IMAGE = "https://customer-assets.emergentagent.com/job_construccion-motril/artifacts/6es8xav6_IMG_4285%20%281%29.jpeg";
const SACOS_YESO_IMAGE = "https://customer-assets.emergentagent.com/job_construccion-motril/artifacts/otamo5m6_IMG_4277.jpeg";
// Imagen de stock para pinturas
const PAINTER_IMAGE = "https://images.unsplash.com/photo-1679018179962-06922435f6bc?w=800";

const ProductosPage = () => {
  const categorias = [
    {
      id: "aislamientos",
      title: "Aislamientos Acústicos y Térmicos en Motril",
      image: PRODUCT_ISOVER,
      description: `En Fornes e Hijos disponemos de una amplia gama de aislamientos acústicos y térmicos de primeras marcas para profesionales en Motril y alrededores. Destacamos nuestro aislamiento acústico PKB2, un producto exclusivo del que pocos distribuidores disponen, ideal para conseguir los mejores resultados en insonorización.

      También trabajamos con lana de roca, lana de vidrio, Acustidan y otros materiales aislantes de última generación. Nuestros aislamientos están diseñados para cumplir con las exigencias del Código Técnico de la Edificación (CTE) en materia de ahorro energético y protección frente al ruido.

      Marcas disponibles: Isover, Rockwool, Danosa, entre otras. Contamos con stock permanente de los formatos más demandados y realizamos pedidos especiales bajo petición.`,
      productos: ["Aislamiento acústico PKB2", "Lana de vidrio (mantas y paneles)", "Lana de roca", "Acustidan", "XPS y EPS", "Aislamiento reflexivo"]
    },
    {
      id: "yesos",
      title: "Yesos y Revestimientos Profesionales",
      image: SACOS_YESO_IMAGE,
      description: `Somos especialistas en yesos y revestimientos para profesionales en Motril. Suministramos yesos de construcción, yesos de proyección, escayolas y pastas de acabado de las mejores marcas del mercado.

      Nuestro equipo cuenta con más de 30 años de experiencia en el sector, lo que nos permite asesorarte sobre el producto más adecuado para cada aplicación: enlucidos, guarnecidos, molduras, y trabajos de restauración.

      Disponemos de yeso manual y yeso de proyección, con diferentes tiempos de fraguado según las necesidades de tu obra. Marcas: Proyal XI, Bortolo, entre otras marcas líderes.`,
      productos: ["Yeso manual", "Yeso de proyección", "Escayola", "Pastas de acabado", "Pasta de juntas"]
    },
    {
      id: "placas",
      title: "Placas de Yeso Laminado (Pladur) Estándar y Técnicas",
      image: PRODUCT_PLACO,
      description: `Tu tienda de yeso laminado (pladur) en Motril. En Fornes e Hijos ofrecemos una completa gama de placas de yeso laminado para todo tipo de aplicaciones: tabiquería, trasdosados, techos y soluciones técnicas especiales.

      Trabajamos con placas estándar (BA13), placas hidrófugas para zonas húmedas, placas ignífugas con resistencia al fuego, placas de alta dureza para zonas de impacto, placas acústicas, placas aligeradas para techos y la placa 4PRO con los cuatro cantos biselados para un acabado perfecto.

      Disponemos de diferentes espesores y formatos. Stock permanente en Motril. Marcas: Placo Saint-Gobain, Gypsotech, entre otras marcas líderes.`,
      productos: ["Placas estándar BA13", "Placas hidrófugas (H1)", "Placas ignífugas (F)", "Placas de alta dureza", "Placas acústicas", "Placa aligerada para techo", "Placa 4PRO (4 cantos biselados)"]
    },
    {
      id: "perfileria",
      title: "Perfilería y Accesorios para Yeso Laminado",
      image: PERFILERIA_IMAGE,
      description: `Complementa tus instalaciones de yeso laminado (pladur) con nuestra perfilería y accesorios de calidad profesional. Disponemos de todos los elementos necesarios para la correcta instalación de sistemas de placas de yeso laminado en Motril.

      Ofrecemos montantes, canales, angular de protección, cinta de papel y malla, tornillería específica, suspensiones, horquillas y todos los accesorios necesarios para tabiques, trasdosados y techos continuos.

      Trabajamos con perfiles de diferentes calibres y longitudes. Stock permanente de los formatos estándar y posibilidad de pedidos especiales para grandes obras.`,
      productos: ["Montantes (48, 70, 90 mm)", "Canales (48, 70, 90 mm)", "Angular de protección", "Tornillería para yeso laminado", "Suspensiones y horquillas", "Cinta de papel y malla"]
    },
    {
      id: "pinturas",
      title: "Pinturas Específicas para Yeso Laminado (Pladur)",
      image: PAINTER_IMAGE,
      description: `Completa tus instalaciones con pinturas de excelente calidad específicas para superficies de yeso laminado (pladur). Ofrecemos pintura acrílica y pintura especial para pladur que garantizan un acabado perfecto.

      Nuestras pinturas están formuladas para adherirse correctamente al cartón de las placas y ofrecer un acabado uniforme y duradero.

      Asesoramiento incluido: te ayudamos a elegir el producto adecuado según el tipo de placa, la estancia y el acabado deseado. Tanto si eres profesional como si estás empezando.`,
      productos: ["Pintura acrílica", "Pintura especial para yeso laminado (pladur)"]
    }
  ];

  return (
    <div className="industrial-bg" data-testid="productos-page">
      {/* Hero */}
      <section className="bg-[#1A365D] py-16">
        <div className="section-container">
          <nav className="text-sm text-gray-400 mb-4" aria-label="Breadcrumb">
            <ol className="flex items-center gap-2">
              <li><Link to="/" className="hover:text-white">Inicio</Link></li>
              <li><ChevronRight className="w-4 h-4" /></li>
              <li className="text-white">Productos</li>
            </ol>
          </nav>
          <h1 className="font-heading text-4xl sm:text-5xl font-bold text-white uppercase mb-4">
            Productos para Profesionales en Motril
          </h1>
          <p className="text-lg text-gray-300 max-w-3xl">
            Materiales de construcción para yesistas, escayolistas e instaladores de yeso laminado (pladur). 
            Stock disponible y servicio a obra en toda la Costa Tropical.
          </p>
        </div>
      </section>

      {/* Quick Nav */}
      <section className="bg-white border-b border-gray-200 sticky top-[120px] z-30">
        <div className="section-container py-4 overflow-x-auto">
          <div className="flex gap-4 min-w-max">
            {categorias.map((cat) => (
              <a
                key={cat.id}
                href={`#${cat.id}`}
                className="px-4 py-2 text-sm font-medium text-[#4A5568] hover:text-[#3182CE] hover:bg-blue-50 rounded-sm transition-colors whitespace-nowrap"
                data-testid={`nav-${cat.id}`}
              >
                {cat.title.split(' en')[0]}
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* Product Categories */}
      <section className="py-16">
        <div className="section-container space-y-24">
          {categorias.map((categoria, index) => (
            <article
              key={categoria.id}
              id={categoria.id}
              className="scroll-mt-48"
              data-testid={`categoria-${categoria.id}`}
            >
              <div className={`grid lg:grid-cols-2 gap-12 items-start ${index % 2 === 1 ? 'lg:flex-row-reverse' : ''}`}>
                {/* Image */}
                <div className={index % 2 === 1 ? 'lg:order-2' : ''}>
                  <img
                    src={categoria.image}
                    alt={categoria.title}
                    className="w-full h-auto rounded-sm shadow-lg"
                    loading="lazy"
                  />
                </div>

                {/* Content */}
                <div className={index % 2 === 1 ? 'lg:order-1' : ''}>
                  <h2 className="font-heading text-2xl sm:text-3xl font-bold text-[#1A365D] uppercase mb-6">
                    {categoria.title}
                  </h2>
                  <div className="prose prose-lg text-[#4A5568] mb-8">
                    {categoria.description.split('\n\n').map((paragraph, i) => (
                      <p key={i} className="mb-4">{paragraph.trim()}</p>
                    ))}
                  </div>

                  {/* Product List */}
                  <div className="bg-white p-6 rounded-sm border border-gray-200 mb-6">
                    <h3 className="font-heading text-lg font-bold text-[#1A365D] mb-4">
                      Productos Disponibles:
                    </h3>
                    <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                      {categoria.productos.map((producto, i) => (
                        <li key={i} className="flex items-center gap-2 text-[#4A5568]">
                          <div className="w-1.5 h-1.5 bg-[#3182CE] rounded-full flex-shrink-0"></div>
                          {producto}
                        </li>
                      ))}
                    </ul>
                  </div>

                  <a
                    href="tel:858130213"
                    className="btn-primary inline-flex items-center gap-2"
                    data-testid={`cta-${categoria.id}`}
                  >
                    <Phone className="w-5 h-5" />
                    Consultar Disponibilidad
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>

      {/* CTA Final */}
      <section className="py-16 bg-[#1A365D]">
        <div className="section-container text-center">
          <h2 className="font-heading text-3xl font-bold text-white uppercase mb-4">
            ¿Necesitas Asesoramiento?
          </h2>
          <p className="text-lg text-gray-300 mb-8 max-w-2xl mx-auto">
            Nuestro equipo está disponible para ayudarte a elegir 
            los materiales más adecuados para tu proyecto. Tanto si eres profesional como si estás empezando.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="tel:622339574"
              className="inline-flex items-center justify-center gap-2 bg-white text-[#1A365D] font-semibold px-6 py-3 rounded-sm hover:bg-gray-100 transition-colors"
              data-testid="productos-cta-asesoria"
            >
              <Phone className="w-5 h-5" />
              Asesoramiento Técnico y Comercial: 622 339 574
            </a>
            <Link
              to="/contacto"
              className="inline-flex items-center justify-center gap-2 border-2 border-white text-white font-semibold px-6 py-3 rounded-sm hover:bg-white/10 transition-colors"
              data-testid="productos-cta-contacto"
            >
              Enviar Consulta
              <ChevronRight className="w-5 h-5" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProductosPage;
